import { ReactElement } from 'react';
import { Typography } from 'antd';
import { Trans } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { LanguageDropdownComponent } from 'common/components/LanguageDropdown/LanguageDropdown.component';
import { Logo } from 'common/components/Logo/Logo';
import { ENV_COMPANY_NAME } from 'common/constants/env.constants';
import {
  SContainer,
  SHeader,
  SLanguageSwitcher,
  SContent,
} from './auth-layout.style';

const AuthLayoutComponent = (): ReactElement => (
  <SContainer>
    <SHeader>
      <Logo width="224" />
      <SLanguageSwitcher>
        <LanguageDropdownComponent />
      </SLanguageSwitcher>
    </SHeader>
    <SContent>
      <Outlet />
    </SContent>
    <footer>
      <Typography.Text type="secondary">
        <Trans i18nKey="ui.footer.copyright" values={{ companyName: ENV_COMPANY_NAME }} />
      </Typography.Text>
    </footer>
  </SContainer>
);

export default AuthLayoutComponent;
